import React from 'react';
import Footer from './Footer';

const FooterWrapper = () => {
  const showCookieConsent = () => {
    // Set a flag in localStorage to indicate we want to show the cookie consent
    localStorage.setItem('show_cookie_consent', 'true');
    
    // Dispatch a custom event that App.js can listen for
    const event = new CustomEvent('show-cookie-consent');
    window.dispatchEvent(event);
  };

  return <Footer onShowCookieConsent={showCookieConsent} />;
};

export default FooterWrapper; 